import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { channels } from "../../mocks/chigua";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/baoliao", label: "吃瓜爆料" },
  { to: "/about", label: "关于我们" },
  { to: "/faq", label: "常见问题" },
  { to: "/contact", label: "联系我们" },
];

function Brand() {
  return (
    <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="今天吃瓜 首页">
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-sm font-bold text-background-50">瓜</span>
      <span className="flex flex-col leading-none">
        <span className="font-heading text-lg font-black tracking-wide text-primary-700">今天吃瓜</span>
        <span className="text-[10px] font-medium tracking-[0.2em] text-foreground-500">今日爆料 · 最新瓜速览</span>
      </span>
    </Link>
  );
}

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [menu, setMenu] = useState(false);

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-primary-600 text-background-50">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-1.5 md:px-6">
          <p className="flex items-center gap-2 text-xs font-medium">
            <i className="ri-time-line" aria-hidden="true" />
            <span className="hidden sm:inline">今日吃瓜速览 · 理性吃瓜，先看后议</span>
            <span className="sm:hidden">今日吃瓜速览</span>
          </p>
          <div className="flex items-center gap-4 text-xs">
            <a href="mailto:gossip@jintianchigua.com" className="hidden items-center gap-1.5 opacity-90 hover:opacity-100 md:flex">
              <i className="ri-mail-line" aria-hidden="true" />
              投稿报料
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 whitespace-nowrap transition hover:bg-background-50/25"
            >
              <i className="ri-search-line text-sm" aria-hidden="true" />
              搜瓜
            </button>
          </div>
        </div>
      </div>

      <div className="border-b border-background-200/80 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 md:px-6">
          <Brand />
          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-full px-4 py-2 text-sm font-medium whitespace-nowrap transition ${
                    isActive
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-700 hover:bg-background-200/70 hover:text-primary-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <button
            type="button"
            onClick={() => setMenu((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-300 text-foreground-800 md:hidden"
            aria-label="打开菜单"
            aria-expanded={menu}
          >
            <i className={menu ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"} aria-hidden="true" />
          </button>
        </div>

        {/* 搜索浮层 */}
        {open && (
          <div className="mx-auto max-w-7xl px-4 pb-3 md:px-6">
            <Link
              to="/baoliao"
              className="flex w-full items-center gap-3 rounded-xl border border-background-300 bg-background-100 px-4 py-2.5 text-sm text-foreground-500 transition hover:border-primary-300"
            >
              <i className="ri-search-line" aria-hidden="true" />
              输入想吃的瓜，回车直达爆料库搜索……
              <span className="ml-auto rounded-md border border-background-300 bg-background-50 px-2 py-0.5 text-xs">搜索</span>
            </Link>
          </div>
        )}

        {/* 移动端菜单 */}
        {menu && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <nav className="flex flex-col gap-1" aria-label="移动端导航">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === "/"}
                  onClick={() => setMenu(false)}
                  className={({ isActive }) =>
                    `rounded-lg px-4 py-2.5 text-sm font-medium ${
                      isActive ? "bg-primary-500 text-background-50" : "text-foreground-800 hover:bg-background-200/70"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <div className="mt-3 border-t border-background-200 pt-3">
              <p className="mb-2 px-1 text-xs font-semibold text-foreground-500">热门频道</p>
              <div className="flex flex-wrap gap-2">
                {channels.map((c) => (
                  <Link
                    key={c.key}
                    to={`/baoliao?channel=${c.key}`}
                    onClick={() => setMenu(false)}
                    className="rounded-full bg-secondary-100 px-3 py-1.5 text-xs font-medium text-secondary-900"
                  >
                    {c.name}
                  </Link>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}